module.exports = new __parcel__URL__("copy.c779f593.svg").toString();